<template>
    <div v-if="!nodata" translate="no" class="margin-top-20 margin-left-20">
        <b-overlay :show="show">
            <div class="select-container no-print mt-4 ml-6">
                <div class="select-group">
                    <div class="relative flex-shrink-0">
                        <select v-model="selectedYear" class="custom-select" @change="onYearChange">
                            <option v-for="option in yearOptions" :key="option.value" :value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <div class="select-arrow">
                            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                    <div class="relative flex-shrink-0">
                        <select v-model="selectedMonth" class="custom-select" @change="onMonthChange">
                            <option v-for="option in monthOptions" :key="option.value" :value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <div class="select-arrow">
                            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div id="printable-content">
                <table width="586" border="0" cellspacing="0" cellpadding="0" align="center">
                    <tbody>
                        <tr>
                            <td>
                                <table width="100%" border="0" cellpadding="0" cellspacing="0">
                                    <tbody>
                                        <tr>
                                            <td style="font-size:11px; color:red;">[별지 제11호 서식]</td>
                                            <td align="right" style="font-size:11px; color:red;">[00]</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table width="100%" style="border:1px solid red; border-collapse:collapse;">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table width="100%" style="border-collapse:collapse;">
                                                    <tbody>
                                                        <tr>
                                                            <td width="70%" align="center" style="padding:5px 0;">
                                                                <span
                                                                    style="font-size:22px; color:red; font-weight:bold;">세
                                                                    금 계 산 서</span>
                                                                <span style="font-size:11px; color:red;">({{
                                                                    detailArr.ADJUST_YEAR }}년 {{
                                                                        detailArr.ADJUST_MONTH }}월 판매분)</span>
                                                            </td>
                                                            <td width="30%">
                                                                <table width="100%" style="border-collapse:collapse;">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="40%"
                                                                                style="border:1px solid red; border-right:none; border-top:none; font-size:11px; text-align:center; padding:1px;">
                                                                                <span style="color:red;">책번호</span>
                                                                            </td>
                                                                            <td width="30%"
                                                                                style="border:1px solid red; border-right:none; border-top:none; font-size:11px; text-align:right; padding-right:5px; color:red;">
                                                                                권
                                                                            </td>
                                                                            <td width="30%"
                                                                                style="border:1px solid red; border-top:none;  text-align:right; border-right:none; font-size:11px;  padding-right:5px; color:red;">
                                                                                호
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td width="40%"
                                                                                style="border:1px solid red; border-right:none; border-top:none; border-bottom:none; font-size:11px; text-align:center; padding:1px;">
                                                                                <span style="color:red;">일련번호</span>
                                                                            </td>
                                                                            <td colspan="2"
                                                                                style="border:1px solid red; border-top:none; border-bottom:none; border-right:none; font-size:11px; text-align:center; padding:1px;">
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <table width="100%" style="border-collapse:collapse;">
                                                    <tbody>
                                                        <tr>
                                                            <td width="50%"
                                                                style="border-top:1px solid red; border-right:1px solid red; border-bottom:1px solid red; padding:0;">
                                                                <table width="100%"
                                                                    style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="20" rowspan="4"
                                                                                style="border-right:1px solid red; text-align:center; vertical-align:middle; padding:0; height:140px;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">공<br>급<br>자</span>
                                                                            </td>
                                                                            <td width="60"
                                                                                style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">등록번호</span>
                                                                            </td>
                                                                            <td
                                                                                style="border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:16px; font-weight:bold;">{{
                                                                                        formatBusinessNumber(detailArr.BUS_NO)
                                                                                    }}</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">상호<br>(법인명)</span>
                                                                            </td>
                                                                            <td
                                                                                style="border-bottom:1px solid red; padding:0; height:35px;">
                                                                                <table width="100%"
                                                                                    style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                                {{ detailArr.BUS_NM }}
                                                                                            </td>
                                                                                            <td width="20"
                                                                                                style="border-left:1px solid red; border-right:1px solid red; text-align:center; height:35px; vertical-align:middle;">
                                                                                                <span
                                                                                                    style="font-size:11px; color:red;">성<br>명</span>
                                                                                            </td>
                                                                                            <td width="80"
                                                                                                style="text-align:center; font-size:11px; height:35px; vertical-align:middle;">
                                                                                                {{ detailArr.CEO_NM
                                                                                                }}<span
                                                                                                    style="color:red;">(인)</span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">사업장<br>주소</span>
                                                                            </td>
                                                                            <td
                                                                                style="border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:10px; word-break:break-all; word-wrap:break-word;">{{
                                                                                        detailArr.BUS_ADDR }}</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                style="border-right:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">업태</span>
                                                                            </td>
                                                                            <td style="padding:0; height:35px;">
                                                                                <table width="100%"
                                                                                    style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                                {{ detailArr.BUS_SP }}
                                                                                            </td>
                                                                                            <td width="20"
                                                                                                style="border-left:1px solid red; border-right:1px solid red; text-align:center; height:35px; vertical-align:middle;">
                                                                                                <span
                                                                                                    style="font-size:11px; color:red;">종목</span>
                                                                                            </td>
                                                                                            <td
                                                                                                style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                                {{ detailArr.BUS_TP }}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td width="50%"
                                                                style="border-top:1px solid red; border-bottom:1px solid red; padding:0;">
                                                                <table width="100%"
                                                                    style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width="20" rowspan="4"
                                                                                style="border-right:1px solid red; text-align:center; vertical-align:middle; padding:0; height:140px;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">공<br>급<br>받<br>는<br>자</span>
                                                                            </td>
                                                                            <td width="60"
                                                                                style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">등록번호</span>
                                                                            </td>
                                                                            <td
                                                                                style="border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:16px; font-weight:bold;">220-81-01830</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">상호<br>(법인명)</span>
                                                                            </td>
                                                                            <td
                                                                                style="border-bottom:1px solid red; padding:0; height:35px;">
                                                                                <table width="100%"
                                                                                    style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                                (주)아가방앤컴퍼니
                                                                                            </td>
                                                                                            <td width="20"
                                                                                                style="border-left:1px solid red; border-right:1px solid red; text-align:center; height:35px; vertical-align:middle;">
                                                                                                <span
                                                                                                    style="font-size:11px; color:red;">성<br>명</span>
                                                                                            </td>
                                                                                            <td width="80"
                                                                                                style="text-align:center; font-size:9px; height:35px; vertical-align:middle;">
                                                                                                SHEN
                                                                                                XIANGGUO<br>신상국<span
                                                                                                    style="color:red;">(인)</span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">사업장<br>주소</span>
                                                                            </td>
                                                                            <td
                                                                                style="border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:10px; word-break:break-all; word-wrap:break-word;">서울특별시
                                                                                    강남구 테헤란로207, 8층(역삼동)</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                style="border-right:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                                <span
                                                                                    style="font-size:11px; color:red;">업태</span>
                                                                            </td>
                                                                            <td style="padding:0; height:35px;">
                                                                                <table width="100%"
                                                                                    style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                                제조, 도매<br>부동산
                                                                                            </td>
                                                                                            <td width="20"
                                                                                                style="border-left:1px solid red; border-right:1px solid red; text-align:center; height:35px; vertical-align:middle;">
                                                                                                <span
                                                                                                    style="font-size:11px; color:red;">종목</span>
                                                                                            </td>
                                                                                            <td
                                                                                                style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                                의류, 완구<br>임대
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr style="border-top:1px solid red; ">
                                            <td colspan="2">
                                                <table width="100%" border="0" cellspacing="0" cellpadding="0"
                                                    class="cborder2"
                                                    style="border-top-style:none;border-left-style:none; border-right: none; ">
                                                    <tbody>
                                                        <tr height="20">
                                                            <td class="cborder2"
                                                                style="border-top-style:none;border-left-style:none"
                                                                align="center"><span class="ttxt2">작 성</span></td>
                                                            <td class="cborder2" style="border-top-style:none"
                                                                align="center">
                                                                <span class="ttxt2">공 급 가 액</span>
                                                            </td>
                                                            <td class="cborder2" style="border-top-style:none"
                                                                align="center">
                                                                <span class="ttxt2">세 액</span>
                                                            </td>
                                                            <td class="cborder2"
                                                                style="border-top-style:none; border-right: none;"
                                                                align="center">
                                                                <span class="ttxt2">비 고</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <table width="100%" border="0" cellspacing="0"
                                                                    cellpadding="0">
                                                                    <tbody>
                                                                        <tr height="20">
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none;border-left-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">년</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">월</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">일</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr height="24">
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none;border-left-style:none; border-bottom: none;"
                                                                                align="center">{{ detailArr.ADJUST_YEAR
                                                                                }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{ detailArr.ADJUST_MONTH
                                                                                }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{ detailArr.ADJUST_DAY
                                                                                }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellspacing="0"
                                                                    cellpadding="0">
                                                                    <tbody>
                                                                        <tr height="20">
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-left:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">공란수</span></td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">백</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">십</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none;"
                                                                                align="center"><span
                                                                                    class="ttxt2">억</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">천</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none;"
                                                                                align="center"><span
                                                                                    class="ttxt2">백</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">십</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">만</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">천</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none;"
                                                                                align="center"><span
                                                                                    class="ttxt2">백</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none;      "
                                                                                align="center"><span
                                                                                    class="ttxt2">십</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; "
                                                                                align="center"><span
                                                                                    class="ttxt2">일</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr height="24">
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-left:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    calculateBlankCount(detailArr.MID_FEE_AMT)
                                                                                }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        10) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        9) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        8) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        7) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        6) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        5) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        4) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        3) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        2) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        1) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_AMT,
                                                                                        0) }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellspacing="0"
                                                                    cellpadding="0">
                                                                    <tbody>
                                                                        <tr height="20">
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-left:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">십</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">억</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">천</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">백</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">십</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">만</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">천</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">백</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none"
                                                                                align="center"><span
                                                                                    class="ttxt2">십</span>
                                                                            </td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-right:none;"
                                                                                align="center"><span
                                                                                    class="ttxt2">일</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr height="24">
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-left:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        9) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        8) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        7) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        6) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        5) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        4) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        3) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        2) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        1) }}</td>
                                                                            <td class="cborder2"
                                                                                style="border-top-style:none; border-bottom: none; border-right:none;"
                                                                                align="center">{{
                                                                                    formatNumberToDigit(detailArr.MID_FEE_VAMT,
                                                                                        0) }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td class="cborder2"
                                                                style="border-top-style:none; border-right: none; "
                                                                align="center">00
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <table width="100%" style="border-collapse:collapse;">
                                                    <tbody>
                                                        <tr>
                                                            <td width="4%" align="center"
                                                                style="border:1px solid red; border-right:none; border-left:none">
                                                                <span style="font-size:11px; color:red;">월</span>
                                                            </td>
                                                            <td width="4%" align="center"
                                                                style="border:1px solid red; border-left:none">
                                                                <span style="font-size:11px; color:red;">일</span>
                                                            </td>
                                                            <td width="25%" align="center"
                                                                style="border:1px solid red;">
                                                                <span style="font-size:11px; color:red;">품목</span>
                                                            </td>
                                                            <td width="6%" align="center" style="border:1px solid red;">
                                                                <span style="font-size:11px; color:red;">규격</span>
                                                            </td>
                                                            <td width="6%" align="center" style="border:1px solid red;">
                                                                <span style="font-size:11px; color:red;">수량</span>
                                                            </td>
                                                            <td width="10%" align="center"
                                                                style="border:1px solid red;">
                                                                <span style="font-size:11px; color:red;">단가</span>
                                                            </td>
                                                            <td width="22%" align="center"
                                                                style="border:1px solid red;">
                                                                <span style="font-size:11px; color:red;">공급가액</span>
                                                            </td>
                                                            <td width="17%" align="center"
                                                                style="border:1px solid red;">
                                                                <span style="font-size:11px; color:red;">세액</span>
                                                            </td>
                                                            <td width="6%" align="center"
                                                                style="border:1px solid red; border-right: none ;">
                                                                <span style="font-size:11px; color:red;">비 고</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td align="center"
                                                                style="border:1px solid red; border-right:none; border-left:none">
                                                                {{ detailArr.ADJUST_MONTH }}</td>
                                                            <td align="center" style="border:1px solid red;">{{
                                                                detailArr.ADJUST_DAY }}</td>
                                                            <td align="left"
                                                                style="border:1px solid red; padding-left:5px;">{{
                                                                    detailArr.GOOD1 }}
                                                            </td>
                                                            <td align="center" style="border:1px solid red;"></td>
                                                            <td align="center" style="border:1px solid red;"></td>
                                                            <td align="center" style="border:1px solid red;"></td>
                                                            <td align="right"
                                                                style="border:1px solid red; padding-right:5px;">{{
                                                                    formatNumber(detailArr.MID_FEE_AMT) }}
                                                            </td>
                                                            <td align="right"
                                                                style="border:1px solid red; padding-right:5px;">{{
                                                                    formatNumber(detailArr.MID_FEE_VAMT) }}
                                                            </td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-right: none;"></td>
                                                        </tr>
                                                        <tr>
                                                            <td align="center"
                                                                style="border:1px solid red; border-left: none; border-bottom: none;">
                                                            </td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom: none;"></td>
                                                            <td align="left"
                                                                style="border:1px solid red; padding-left:5px; border-bottom: none;">
                                                                {{ detailArr.GOOD2 }}</td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom: none;"></td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom: none;"></td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom: none;"></td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom: none;"></td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom: none;"></td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-right:none; border-bottom: none;">
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr style="border-top: 1px solid red;">
                                            <td colspan="2">
                                                <table width="100%" style="border-collapse:collapse;">
                                                    <tbody>
                                                        <tr>
                                                            <td width="25%" align="center"
                                                                style="border:1px solid red; border-left: none;">
                                                                <span style="font-size:12px; color:red;">합계금액</span>
                                                            </td>
                                                            <td width="10%" align="center"
                                                                style="border:1px solid red;">
                                                                <span style="font-size:12px; color:red;">현금</span>
                                                            </td>
                                                            <td width="10%" align="center"
                                                                style="border:1px solid red;">
                                                                <span style="font-size:12px; color:red;">수표</span>
                                                            </td>
                                                            <td width="10%" align="center"
                                                                style="border:1px solid red;">
                                                                <span style="font-size:12px; color:red;">어음</span>
                                                            </td>
                                                            <td width="20%" align="center"
                                                                style="border:1px solid red;">
                                                                <span style="font-size:12px; color:red;">외상미수금</span>
                                                            </td>
                                                            <td rowspan="5" align="center"
                                                                style="border-top: 1px solid red;">
                                                                <span style="font-size:12px; color:red;">이 금액을</span>
                                                                <strong> 영수 </strong>
                                                                <span style="font-size:12px; color:red;">함</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td align="center"
                                                                style="border:1px solid red; border-left: none; border-bottom:none">
                                                                {{ formatNumber(detailArr.MID_FEE_TAMT) }}
                                                            </td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom:none;"></td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom:none;"></td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom:none;"></td>
                                                            <td align="center"
                                                                style="border:1px solid red; border-bottom:none;"></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- 버튼 영역 -->
            <div class="action-buttons no-print">
                <div class="button-container">
                    <button class="modern-button print-button" @click="printPage">
                        <PrinterIcon size="20" /> 인쇄
                    </button>
                    <button class="modern-button email-button" @click="openEmailModal">
                        <MailIcon size="20" /> 이메일 발송
                    </button>
                </div>
                <div class="notice-box">
                    <p>*실제 통장입금 금액은 판촉물/부자재 금액 공제 후 입금되기 때문에 차이가 발생 합니다.</p>
                    <p>*판촉물/부자재 내역은 출고반품 현황에서 확인 가능 합니다.(POS-현황관리-출고반품 현황)</p>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import taxAPI from '@/api/tax/tax'
import Swal from 'sweetalert2'
import { PrinterIcon, MailIcon } from 'lucide-vue-next'

const route = useRoute()
const router = useRouter()
const show = ref(false)
const selectedYear = ref('')
const selectedMonth = ref('')
const yearOptions = ref([])
const monthOptions = ref([])
const detailArr = ref({})
const nodata = ref(false)
const dateResponse = ref([])

const formatNumber = (value) => {
    if (!value) return '0'
    return value.toLocaleString()
}

const calculateBlankCount = (value) => {
    if (!value) return 11
    const length = value.toString().length
    return 11 - length
}

const formatBusinessNumber = (number) => {
    if (!number) return ''
    // 숫자만 추출
    const numbers = number.replace(/\D/g, '')
    // 3-2-5 형식으로 변환
    return numbers.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
}

const formatNumberToDigit = (number, position) => {
    if (!number) return '0'
    const numStr = number.toString()
    if (position >= numStr.length) return ''
    return numStr[numStr.length - position - 1] || ''
}

const getDate = async () => {
    show.value = true
    try {
        const response = await taxAPI.getDate(route.params.bus_no)
        if (!response?.length) {
            await Swal.fire({
                icon: 'error',
                title: '등록된 자료가 없습니다',
                text: '담당에게 문의 하시기 바랍니다'
            })
            router.push({ name: 'tax_login' })
            return
        }

        dateResponse.value = response

        // 년도와 월 분리하여 저장
        const years = [...new Set(response.map(item => item.substring(0, 4)))].sort((a, b) => b - a)
        yearOptions.value = years.map(year => ({
            value: year,
            text: year + '년'
        }))

        // 최근 년도 선택
        selectedYear.value = years[0]
        
        // 선택된 년도의 월 옵션 설정
        updateMonthOptions(selectedYear.value)

        // 최근 월 선택
        if (monthOptions.value.length > 0) {
            selectedMonth.value = monthOptions.value[0].value
            await getDetail()
        }
    } catch (error) {
        console.error('세금계산서 기간 조회 실패:', error)
    } finally {
        show.value = false
    }
}

// 월 옵션 업데이트 함수
const updateMonthOptions = (year) => {
    if (!year) {
        monthOptions.value = [];
        return;
    }
    const months = dateResponse.value
        .filter(item => item.startsWith(year))
        .map(item => item.substring(4, 6))
        .sort((a, b) => b - a);
    monthOptions.value = months.map(month => ({
        value: month,
        text: month + '월'
    }));
};

// 년도 변경 시 월 옵션 업데이트 및 세금계산서 조회
const onYearChange = () => {
    updateMonthOptions(selectedYear.value);
    if (monthOptions.value.length > 0) {
        selectedMonth.value = monthOptions.value[0].value;
        getDetail();
    } else {
        selectedMonth.value = '';
        detailArr.value = {};
        nodata.value = true;
    }
};

// 월 변경 시 세금계산서 조회
const onMonthChange = () => {
    if (selectedYear.value && selectedMonth.value) {
        getDetail();
    }
};

// 세금계산서 상세 데이터 조회
const getDetail = async () => {
    if (!selectedYear.value || !selectedMonth.value) return;
    show.value = true;
    try {
        const response = await taxAPI.getDetail(route.params.bus_no, selectedYear.value + selectedMonth.value);
        if (response?.length > 0) {
            detailArr.value = response[0];
            nodata.value = false;
        } else {
            detailArr.value = {};
            nodata.value = true;
        }
    } catch (error) {
        console.error('세금계산서 상세 조회 실패:', error);
        detailArr.value = {};
        nodata.value = true;
    } finally {
        show.value = false;
    }
};

const printPage = () => {
    window.print()
}

const openEmailModal = async () => {
    console.log('📧 이메일 모달 열기 시도')
    try {
        const { value: email } = await Swal.fire({
            title: '이메일 전송',
            text: '받는 메일 주소를 입력해주세요',
            input: 'email',
            inputPlaceholder: 'example@email.com',
            inputValidator: (value) => {
                if (!value) {
                    return '이메일 주소를 입력해주세요'
                }
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(value)) {
                    return '유효한 이메일 주소를 입력해주세요'
                }
                return null
            },
            showCancelButton: true,
            confirmButtonText: '전송',
            cancelButtonText: '취소',
            confirmButtonColor: '#007bff',
            cancelButtonColor: '#6c757d',
            showLoaderOnConfirm: true,
            preConfirm: async (email) => {
                console.log('📧 이메일 주소 확인:', email)
                if (!email) {
                    Swal.showValidationMessage('이메일 주소를 입력해주세요')
                    return false
                }
                return email
            },
            allowOutsideClick: () => !Swal.isLoading()
        })

        if (email) {
            console.log('📧 이메일 전송 시작:', email)
            await sendEmail(email)
        } else {
            console.log('📧 이메일 전송 취소됨')
        }
    } catch (error) {
        console.error('❌ 이메일 모달 오류:', error)
        await Swal.fire({
            icon: 'error',
            title: '오류 발생',
            text: '이메일 모달을 열 수 없습니다'
        })
    }
}

const sendEmail = async (emailAddress) => {
    console.log('📧 sendEmail 함수 시작:', { emailAddress })
    
    if (!emailAddress) {
        console.error('❌ 이메일 주소가 없습니다')
        await Swal.fire({
            icon: 'warning',
            title: '이메일 주소를 입력해주세요'
        })
        return
    }

    try {
        console.log('📄 PDF 생성 준비 중...')
        // 스타일을 포함한 HTML 생성
        const printContent = document.getElementById('printable-content')
        
        if (!printContent) {
            console.error('❌ printable-content 요소를 찾을 수 없습니다')
            throw new Error('세금계산서 내용을 찾을 수 없습니다')
        }
        
        console.log('✅ printable-content 요소 찾음')
        const styles = `
            <style>
                @page {
                    size: A4;
                    margin: 10mm;
                }
                body {
                    margin: 0;
                    padding: 0;
                    font-family: 'Noto Sans KR', 'IPAGothic', 굴림, Gulim, sans-serif;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                table {
                    border-collapse: collapse;
                    width: 100%;
                }
                td {
                    padding: 0;
                    font-size: 12px;
                }
                .cborder2 {
                    border: 1px solid red;
                }
                .ttxt2 {
                    font-family: 'Noto Sans KR', 'IPAGothic', 굴림, Gulim, sans-serif;
                    font-size: 12px;
                    color: red;
                }
                .no-print {
                    display: none !important;
                }
                strong {
                    font-size: 12px !important;
                    font-weight: normal !important;
                }
            </style>
        `
        const htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                ${styles}
            </head>
            <body>
                ${printContent.outerHTML}
            </body>
            </html>
        `
        
        console.log('📦 HTML Base64 인코딩 중...')
        const htmlBase64 = btoa(unescape(encodeURIComponent(htmlContent)))
        console.log('✅ HTML Base64 인코딩 완료, 크기:', (htmlBase64.length / 1024).toFixed(2), 'KB')
        
        console.log('📤 백엔드 API 호출 시작...')
        const response = await taxAPI.sendEmail(emailAddress, htmlBase64)
        console.log('✅ 백엔드 API 응답:', response)
        
        await Swal.fire({
            icon: 'success',
            title: '이메일이 전송되었습니다',
            text: '세금계산서가 성공적으로 전송되었습니다'
        })
    } catch (error) {
        console.error('❌ 이메일 전송 실패:', error)
        console.error('에러 상세:', {
            message: error.message,
            response: error.response,
            stack: error.stack
        })
        
        let errorMessage = '알 수 없는 오류가 발생했습니다'
        if (error.response) {
            // 백엔드에서 반환한 에러
            errorMessage = error.response.data?.error || error.response.data?.details || error.response.statusText
            console.error('백엔드 에러 응답:', error.response.data)
        } else if (error.message) {
            errorMessage = error.message
        }
        
        await Swal.fire({
            icon: 'error',
            title: '이메일 전송에 실패했습니다',
            text: errorMessage,
            footer: '개발자 도구 콘솔에서 상세 정보를 확인할 수 있습니다'
        })
    }
}

onMounted(() => {
    if (!route.params.bus_no) {
        router.push({ name: 'tax_login' })
        return
    }
    getDate()
})
</script>

<style scoped>
.select-group {
    display: flex;
    gap: 10px;
    justify-content: center;
}

.relative {
    position: relative;
}

.custom-select {
    width: 120px;
    height: 36px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 0 32px 0 8px;
    font-size: 14px;
    background: #fff;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none;
    transition: border-color 0.2s;
}

.custom-select:focus {
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

.select-arrow {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
}

.action-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.button-container {
    display: flex;
    gap: 16px;
    justify-content: center;
}

.modern-button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
}

.print-button {
    background-color: #f8f9fa;
    color: #212529;
    border: 1px solid #dee2e6;
}

.print-button:hover {
    background-color: #e9ecef;
}

.email-button {
    background-color: #007bff;
    color: white;
}

.email-button:hover {
    background-color: #0056b3;
}

.notice-box {
    margin-top: 20px;
    padding: 15px;
    border: 1px solid #4a90e2;
    border-radius: 4px;
    background-color: #f8f9ff;
    max-width: 618px;
    margin-left: auto;
    margin-right: auto;
}

.notice-box p {
    margin: 5px 0;
    color: #2c3e50;
    font-size: 14px;
}

.material-icons {
    font-size: 20px;
    margin-right: 4px;
    vertical-align: middle;
}

.modal-content {
    border-radius: 8px;
}

.modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 1rem;
}

.modal-body {
    padding: 1.5rem;
}

.form-group label {
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.form-control {
    border-radius: 4px;
    border: 1px solid #ced4da;
    padding: 0.5rem 0.75rem;
}

.form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
}

@media print {
    @page {
        size: A4;
        margin: 10mm;
    }

    .no-print,
    .navbar,
    .header,
    .footer,
    .select-container,
    .action-buttons,
    header,
    nav,
    .app-bar,
    .profile-section {
        display: none !important;
    }

    body,
    html {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        background-color: white;
    }

    #printable-content {
        margin: 0 auto;
        padding: 0;
        box-sizing: border-box;
        width: 100%;
        height: auto;
        position: relative;
        max-width: 210mm;
    }

    table {
        page-break-inside: avoid;
        width: 100%;
        margin: 0 auto;
    }

    body {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}

body,
table,
tr,
td {
    font-family: 'Noto Sans KR', 'IPAGothic', 굴림, verdana, arial;
    font-size: 12px;
    color: #000000;
}

.ttxt2 {
    font-family: 'Noto Sans KR', 'IPAGothic', 굴림, verdana, arial;
    font-size: 12px;
    color: red;
}

.cborder2 {
    border-width: 1px;
    border-color: red;
    border-style: solid;
}

.ctit2 {
    font-size: 22px;
    color: red;
    font-weight: bold;
}

.ccmt2 {
    font-size: 12px;
    color: red;
}

.taxidno {
    font-size: 16px;
    color: black;
    font-weight: bold;
}

#printable-content {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
